import Vue from "vue";
import Router from "vue-router";
import { authGuard } from "../auth/authGuard";

// Containers
const TheContainer = () => import("@/containers/TheContainer");

// Views
const Dashboard = () => import("@/views/Dashboard");
const Users = () => import("@/views/Users");
const UserProfile = () => import("@/views/UserProfile");
const UserDetails = () => import("@/views/UserDetails");

const AddOrg = () => import("@/views/AddOrg");

const ListOrgs = () => import("@/views/ListOrgs");
const OrgDetails = () => import("@/views/OrgDetails");

const EditUser = () => import("@/views/EditUser");
const AddUser = () => import("@/views/AddUser");
const ListRole = () => import("@/views/ListRole");
const GetRole = () => import("@/views/GetRole");

const ListPorts = () => import("@/views/ListPorts");
const PortDetails = () => import("@/views/PortDetails");

const MachineLearning = () => import("@/views/MachineLearning");

const Page404 = () => import("@/views/pages/Page404");
const Page500 = () => import("@/views/pages/Page500");

Vue.use(Router);

const router = new Router({
  mode: "hash",
  //base: process.env.BASE_URL,
  linkActiveClass: "active",
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes(),
});

function configRoutes() {
  return [
    {
      path: "/",
      redirect: "/dashboard",
      name: "Home",
      component: TheContainer,
      children: [
        {
          path: "dashboard",
          name: "Dashboard",
          component: Dashboard,
        },
        {
          path: "users",
          name: "Users",
          component: Users,
        },
        {
          path: "user-profile",
          name: "User Profile",
          component: UserProfile,
        },
        {
          path: "edit-user",
          name: "Edit User",
          component: EditUser,
        },
        {
          path: "add-user",
          name: "Add User",
          component: AddUser,
        },
        {
          path: "roles",
          name: "Roles",
          component: ListRole,
        },
        // {
        //   path: "add-org",
        //   name: "Add Org",
        //   component: AddOrg,
        // },
        {
          path: "orgs",
          name: "Organizations",
          component: ListOrgs,
          children: [
            {
              path: "items/:org_id",
              name: "Org Details",
              component: OrgDetails,
            },
            {
              path: "add-org",
              name: "Add Org",
              component: AddOrg,
            },
          ],
        },
        {
          path: "roles/:role_id",
          name: "Display Role",
          component: GetRole,
        },
        {
          path: "user-details/:user_id",
          name: "User Details",
          component: UserDetails,
        },
        {
          path: "ports",
          name: "List Ports",
          component: ListPorts,

          children: [
            {
              path: ":port_id",
              name: "Port Details",
              component: PortDetails,
            },
          ],
        },
        {
          path: "ml",
          name: "Machine Learning",
          component: MachineLearning,
        },
      ],
    },
    {
      path: "/pages",
      redirect: "/pages/404",
      name: "Pages",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "404",
          name: "Page404",
          component: Page404,
        },
        {
          path: "500",
          name: "Page500",
          component: Page500,
        },
      ],
    },
  ];
}

router.beforeEach(authGuard);

export default router;
